module.exports = __webpack_public_path__ + "img/logo.5e503fb2.svg";